import React, { useEffect, useState } from "react";
import Textarea from "../FormComponents/Textarea";
import ErrorMessage from "../FormComponents/ErrorMessage";

const JsonTextareaField = ({ label, jsonValue, onChange, disabled = false }) => {
  const [textValue, setTextValue] = useState("");
  const [error, setError] = useState("");

  // Sync input value with parsed JSON
  useEffect(() => {
    if (typeof jsonValue === "object") {
      try {
        const formatted = JSON.stringify(jsonValue, null, 2);
        setTextValue(formatted);
        setError("");
      } catch (err) {
        setTextValue("");
        setError("Failed to stringify JSON.");
      }
    }
  }, [jsonValue]);

  const handleBlur = () => {
    if (disabled) return;

    try {
      const parsed = JSON.parse(textValue);
      setError("");
      onChange(parsed); // Pass parsed object/array back to parent
    } catch (err) {
      setError("Invalid JSON format. Please correct the input.");
    }
  };

  return (
    <div className="builder_form">
      <Textarea
        label={label}
        value={textValue}
        onChange={(e) => setTextValue(e.target.value)}
        onBlur={handleBlur}
        disabled={disabled}
        placeholder="Enter valid JSON"
        style={{ minHeight: "200px" }}
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  );
};

export default JsonTextareaField;
